<template>
  <BulkActionMenu :actions="actions">
    <template v-slot:approval>
      <VarianceApprovalDrawer
        :items="items"
        :resource="resource"
        :resource-id="resourceId"
        :variance="variance"
        :selected-items-id="selectedItemIds"
        bulk-action
        @refresh="$emit('refresh')"
      />
    </template>
    <template v-slot:reject>
      <VarianceRejectionDrawer
        :items="items"
        :resource="resource"
        :resource-id="resourceId"
        :variance="variance"
        :selected-items-id="selectedItemIds"
        bulk-action
        @refresh="$emit('refresh')"
      />
    </template>
  </BulkActionMenu>
</template>

<script>
import BulkActionMenu from '@components/bulk-action-menu'
import VarianceApprovalDrawer from './variance-approval-drawer'
import VarianceRejectionDrawer from './variance-rejection-drawer'
export default {
  name: 'BulkActions',
  components: {
    BulkActionMenu,
    VarianceApprovalDrawer,
    VarianceRejectionDrawer,
  },
  props: {
    items: { type: Array, required: true },
    selectedItemIds: { type: Array, required: true },
    toggleSelectAll: { type: Function, required: true },
    refreshList: { type: Function, required: true },
    variance: {
      type: Array,
      default: undefined,
    },
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
  },
  data() {
    let actions = ['approval', 'reject']
    this.actions = actions
    return {}
  },
  computed: {
    selectedItems() {
      return this.selectedItemIds.map((id) =>
        (this.items || []).find((i) => i.id === id)
      )
    },
  },
  methods: {
    unselectAll() {
      this.toggleSelectAll()
    },
  },
}
</script>
